var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deviceMd)?_c('span',[_c('router-link',{staticClass:"btn-compare btn btn-favourite px-4 py-2",attrs:{"to":"/compare","event":"","tag":"button"},nativeOn:{"click":function($event){$event.preventDefault();_vm.checkFloorplanList()}}},[_vm._v("\n    Compare\n  ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ff791f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Floorplan/CompareButton.vue
// module id = null
// module chunks = 